import { CommunityData } from '../server/types';
import { UserPost, UserPostComment } from '../types/posts';

// Commnuity state data class
class CommunityStateData {

	communities: CommunityData[] = [
		{"id":"1","owner_id":"1","community_name":"Peyto","community_tag_line":"One community, Every sport.","community_description":"Welcome to the Peyto Community. Join us for the best moments, people, and stories across all sports","community_icon_img":"/imgs/temp/community/temp-icon.png","community_hero_img":"/imgs/temp/community/temp-icon.png","create_date":"2026-01-22T17:42:47.000Z"}
		,{"id":"2","owner_id":"1","community_name":"Peyto Ski & Snowboard","community_tag_line":"The home of ski & snowboard on Peyto","community_description":"The official ski & snowboard community on Peyto. Join for mountain moments, creators, events, and conversations.","community_icon_img":"/imgs/temp/community/temp-icon.png","community_hero_img":"/imgs/temp/community/temp-icon.png","create_date":"2026-01-22T17:42:47.000Z"}
		,{"id":"3","owner_id":"1","community_name":"Community #3","community_tag_line":"Test Community Number 1","community_description":"This is a test community for testing database integrety and data requests","community_icon_img":"/imgs/temp/community/temp-icon.png","community_hero_img":"/imgs/temp/community/temp-icon.png","create_date":"2026-01-22T17:42:47.000Z"}
		,{"id":"4","owner_id":"1","community_name":"Community #4","community_tag_line":"Test Community Number 1","community_description":"This is a test community for testing database integrety and data requests","community_icon_img":"/imgs/temp/community/temp-icon.png","community_hero_img":"/imgs/temp/community/temp-icon.png","create_date":"2026-01-22T17:42:47.000Z"}
		,{"id":"5","owner_id":"1","community_name":"Community #5","community_tag_line":"Test Community Number 1","community_description":"This is a test community for testing database integrety and data requests","community_icon_img":"/imgs/temp/community/temp-icon.png","community_hero_img":"/imgs/temp/community/temp-icon.png","create_date":"2026-01-22T17:42:47.000Z"}
		,{"id":"6","owner_id":"1","community_name":"Community #6","community_tag_line":"Test Community Number 1","community_description":"This is a test community for testing database integrety and data requests","community_icon_img":"/imgs/temp/community/temp-icon.png","community_hero_img":"/imgs/temp/community/temp-icon.png","create_date":"2026-01-22T17:42:47.000Z"}
	]

	userCommunities: CommunityData[] = []

	userPosts: UserPost[] = []

	loadedComments: UserPostComment[] = []

	public isMemberOfCommunity(communityId: string) {
		let isMember: boolean = false
		this.userCommunities.forEach((communityData: CommunityData) => {
			if (communityData.id == communityId) {
				isMember = true
			}
		})
		return isMember
		// return this.communityIds.includes(parseInt(communityId))
	}

	public increasePostCommentCount(postId: string) {
		let newUserPosts: UserPost[] = [...this.userPosts]
		for (let i:number = 0; i < newUserPosts.length; i++) {
			if (newUserPosts[i].postId == postId) {
				let newUserPost: UserPost = {...newUserPosts[i], ...{commentCount: String(Number(newUserPosts[i].commentCount) + 1)}}
				// newUserPosts[i].commentCount = String(Number(newUserPosts[i].commentCount) + 1)
				newUserPosts[i] = newUserPost
				// if (this.userPosts[i].commentCount !== undefined) {
				// 	this.userPosts[i].commentCount = this.userPosts[i].commentCount + 1
				// }
				// const newValue: number = parseInt(this.userPosts[i].commentCount)
				// this.userPosts[i].commentCount = `${parseInt(this.userPosts[i].commentCount ? this.userPosts[i].commentCount : ) + 1}`
			}
		}
		this.userPosts = newUserPosts
	}
	// [{
	// 		postId: '1',
	// 		sourceName: 'Test User',
	// 		community: 'Community Name #1',
	// 		sourceImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl() || '',
	// 		postDate: 0,
	// 		postMsg: 'This is an example test post',
	// 		postImgSrc: undefined,
	// 		verified: true
	// 	}
	// ]


	// 	{
	// 		postId: '1',
	// 		sourceName: 'Test User',
	// 		community: 'Community Name',
	// 		sourceImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl() || '',
	// 		postDate: 0,
	// 		postMsg: 'This is an example fake post used for testing the front end layout',
	// 		postImgSrc: undefined,
	// 		verified: true
	// 	},{
	// 		postId: '2',
	// 		sourceName: 'Test User',
	// 		community: 'Community Name',
	// 		sourceImgSrc: userStateData.getUserIconUrl() || '',
	// 		postDate: 0,
	// 		postMsg: 'This is an example fake post with an image',
	// 		postImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl(),
	// 		verified: true
	// 	},{
	// 		postId: '3',
	// 		sourceName: 'Test User',
	// 		community: 'Community Name',
	// 		sourceImgSrc: 'https://skivio.co/uploads/profile_pics/1756864061131-fileName.jpg', // userStateData.getUserIconUrl() || '',
	// 		postDate: 0,
	// 		postMsg: 'Another fake post to test stacked posts in layout',
	// 		postImgSrc: undefined,
	// 		verified: true
	// 	}
	// ]
	
	constructor() {
	}
}

export const communityStateData: CommunityStateData = new CommunityStateData()